






import { Component, Vue } from 'vue-property-decorator';
import bottom_device from '../../assets/image/bottom_device.png';
import bottom_device_active from '../../assets/image/bottom_device_active.png';
import alarm_history from '../../assets/image/alarm_history.png';
import alarm_history_active from '../../assets/image/alarm_history_active.png';
import personal_info from '../../assets/image/personal_info.png';
import personal_info_active from '../../assets/image/personal_info_active.png';
// 声明组件*****************
@Component
export default class BottomNav extends Vue {
  // 属性*****************
  name: string = 'BottomNav';
  private bottomNavList: Array<any> = [
      {
          src: bottom_device,
          activeSrc: bottom_device_active,
          title: '设备',
          to: '/weixin/communityfire/device'
      },
    //   {
    //       src: alarm_history,
    //       activeSrc: alarm_history_active,
    //       title: '报警历史',
    //       to: '/weixin/communityfire/alarmhistory'
    //   },
      {
          src: personal_info,
          activeSrc: personal_info_active,
          title: '账号信息',
          to: '/weixin/communityfire/personalinfo'
      },
  ];
 

  // 方法*****************

}
